"use client";

import { Button } from "@/components/button";

type CallButtonProps = {
  phone: string;
};

export default function CallButton({ phone }: Readonly<CallButtonProps>) {
  if (!phone) return null;

  return (
    <Button
      variant="bare"
      type="button"
      text="دریافت مشاوره رایگان"
      onClick={() => {
        window.location.href = `tel:${phone}`;
      }}
      className="w-36 md:w-49.75 h-10 md:h-12 cursor-pointer bg-primary text-sm md:text-base hover:bg-blue-700 text-white font-normal rounded-[50px] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
    />
  );
}
